import React from 'react';
import PropTypes from 'prop-types';
import { Typography, Tooltip, makeStyles } from '@material-ui/core';
import { useIntl } from 'react-intl';

const useTooltipStyles = makeStyles(theme => ({
  tooltip: {
    whiteSpace: 'pre-line',
    maxWidth: theme.spacing(50)
  }
}));

const useStyles = makeStyles(theme => ({
  srOnly: {
    height: '1px',
    width: '1px',
    margin: '-1px',
    overflow: 'hidden',
    padding: 0,
    position: 'absolute'
  },
  naText: {
    ...theme.typography.caption,
    color: theme.palette.text.secondary,
    fontStyle: 'italic',
    cursor: 'help'
  }
}));

export const NALabel = ({ tooltipTitle }) => {
  const classes = useStyles();
  const tooltipClasses = useTooltipStyles();
  const { formatMessage } = useIntl();

  return (
    <Tooltip title={tooltipTitle} classes={tooltipClasses}>
      <Typography className={classes.naText}>
        {formatMessage({ id: 'nullableMoneyValue.na' })}
        <span className={classes.srOnly}>{tooltipTitle}</span>
      </Typography>
    </Tooltip>
  );
};

NALabel.propTypes = {
  tooltipTitle: PropTypes.node
};

export default NALabel;
